"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDeviceInfo = void 0;
const Misc_1 = require("./Misc");
exports.EmptyDeviceInfo = {
    nucleusDataType: "device",
    deviceId: "",
    serialNo: "",
    accountId: "",
    patientId: "",
    reboot: false,
    remoteLogs: false,
    locationInfo: Misc_1.EmptyLocationInfo,
    hexnodeId: 0,
    mdmId: 0,
    deviceName: "",
    deviceNotAssigned: false,
    serverUTCTime: 0,
};
